    <fieldmagic-dropdown-input
      #dropdownInput
      [standalone]="true"
      [options]="fields$ | async"
      [placeholder]="'variable_select_field_to_add' | translate"
      [grouped]="true"
      [isOpen]="isOpen"
      (change)="fieldChange.emit($event)"
      (blur)="onBlur()"
    ></fieldmagic-dropdown-input>
